"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchRedirect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchRedirect, _Component);

  var _super = _createSuper(SearchRedirect);

  function SearchRedirect() {
    var _this;

    (0, _classCallCheck2.default)(this, SearchRedirect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isVisible: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleHideClick", function () {
      _this.setState({
        isVisible: false
      }, function () {
        window.dispatchEvent(new Event('resize'));
      });
    });
    return _this;
  }

  (0, _createClass2.default)(SearchRedirect, [{
    key: "render",
    value: function render() {
      var isVisible = this.state.isVisible;

      if (!isVisible) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "search-redirect-panel",
        "data-bounded-context": "Autopilot",
        "data-entity": "search-redirect"
      }, (0, _preact.h)("div", {
        className: "welcome-wrapper"
      }, (0, _preact.h)("strong", null, (0, _preact.h)(_phrase.default, {
        p: "autopilot.overview.welcomeTo"
      }), "\xA0", (0, _preact.h)(_phrase.default, {
        p: "autopilot.overview.title"
      }), "!"), (0, _preact.h)("span", {
        className: "redirect-message"
      }, (0, _preact.h)(_phrase.default, {
        p: "autopilot.overview.description"
      }))), (0, _preact.h)("div", {
        className: "redirect-actions"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/search"),
        className: "link",
        "data-track-type": "click",
        "data-element-name": "Link to Search Page"
      }, (0, _preact.h)(_phrase.default, {
        p: "autopilot.overview.goToSearch"
      })), (0, _preact.h)("a", {
        href: "#",
        className: "link",
        onClick: this.handleHideClick
      }, (0, _preact.h)(_phrase.default, {
        p: "autopilot.overview.hide"
      }))));
    }
  }]);
  return SearchRedirect;
}(_preact.Component);

exports.default = SearchRedirect;